import {
    OrdersCreatePage,
    OrdersPage,
    OrderDetailsPage,
    OrderEditDocumentPage,
    OrderEditSourcePage,
    OrderStylesheetPage,
    OrderStatisticPage,
    OrderDefaultSpeakersPage,
    OrderNotFoundPage,
} from './views';

const routes = [
    {
        path: '/orders',
        name: 'orders',
        component: OrdersPage,
        meta: {
            title: 'Orders',
        },
    },
    {
        path: '/orders/create',
        name: 'orders-create',
        component: OrdersCreatePage,
        meta: {
            title: 'Create Order',
        },
    },
    {
        path: '/orders/:id',
        name: 'orders-id',
        component: OrderDetailsPage,
        meta: {
            title: 'Orders',
        },
    },
    {
        path: '/orders/:id/document',
        name: 'orders-id-document',
        component: OrderEditDocumentPage,
        meta: {
            title: 'Edit Document',
        },
    },
    {
        path: '/orders/:id/source',
        name: 'orders-id-source',
        component: OrderEditSourcePage,
        meta: {
            title: 'Edit Source',
        },
    },
    {
        path: '/orders/:id/stylesheet',
        name: 'orders-id-stylesheet',
        component: OrderStylesheetPage,
        meta: {
            title: 'Style sheet',
        },
    },
    {
        path: '/orders/:id/statistic',
        name: 'orders-id-statistic',
        component: OrderStatisticPage,
        meta: {
            title: 'Statistic',
        },
    },
    {
        path: '/orders/:id/default-speakers',
        name: 'orders-id-default-speakers',
        component: OrderDefaultSpeakersPage,
        meta: {
            title: 'Default speakers',
        },
    },
    {
        path: '/orders/orders-not-found',
        name: 'orders-not-found',
        component: OrderNotFoundPage,
        meta: {
            title: 'Not found',
        },
    },
];

export default routes;
